import type { Action } from 'redux';

import type { NormalizedAllCampaignsEntities } from '../../normalization/graphql/normalizeAllCampaigns.types';

import type { AllCampaignsLoadOptions } from './shared.types';

export const campaignsListRequestStatusKey = 'campaignsListRequestKey';

export interface CampaignsListLoadMorePendingAction extends Action {
  readonly type: 'ALL_CAMPAIGNS.LOAD_MORE_PENDING';
  readonly campaignsListRequestStatusKey: string;
}

export interface CampaignsListLoadMoreFulfilledAction extends Action {
  readonly type: 'ALL_CAMPAIGNS.LOAD_MORE_FULFILLED';
  readonly campaignsListRequestStatusKey: string;
  readonly payload: {
    readonly options: AllCampaignsLoadOptions;
    readonly entities: NormalizedAllCampaignsEntities;
  };
}

export interface CampaignsListLoadMoreRejectedAction extends Action {
  readonly type: 'ALL_CAMPAIGNS.LOAD_MORE_REJECTED';
  readonly campaignsListRequestStatusKey: string;
  readonly payload: {
    readonly error: unknown;
  };
  readonly error: true;
}

export type CampaignsListLoadMoreAction =
  | CampaignsListLoadMorePendingAction
  | CampaignsListLoadMoreFulfilledAction
  | CampaignsListLoadMoreRejectedAction;
